import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { InputField, Button } from '@unite-us/ui';
import { get, isEmpty, first } from 'lodash';
import { Field, Form } from 'react-final-form';
import enums from '../../../constants/enums';
import EnumSelect from '../../common/EnumSelect';
import ScrollFieldIntoView from '../../common/ScrollFieldIntoView';
import { callbacks, getAdapter, trackEvent } from '../../../config/api';
import formatNicknames from '../../utils/formatNicknames';
import { isRequired } from '../../utils/validations';
import { FACESHEET } from '../../../constants/eventConstants';
import callOrLog from '../../../constants/callOrLog';
function PersonalInformationForm(props) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    formErrors = _useState2[0],
    setFormErrors = _useState2[1];
  var onCancel = function onCancel() {
    props.closeModal();
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      var _values$title, _values$first_name, _values$middle_name, _values$last_name, _values$suffix, _values$nicknames;
      var contact, contactId, newContact;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            contact = props.contact;
            contactId = get(contact, 'id');
            newContact = {
              title: (_values$title = values.title) !== null && _values$title !== void 0 ? _values$title : null,
              first_name: (_values$first_name = values.first_name) !== null && _values$first_name !== void 0 ? _values$first_name : null,
              middle_name: (_values$middle_name = values.middle_name) !== null && _values$middle_name !== void 0 ? _values$middle_name : null,
              last_name: (_values$last_name = values.last_name) !== null && _values$last_name !== void 0 ? _values$last_name : null,
              suffix: (_values$suffix = values.suffix) !== null && _values$suffix !== void 0 ? _values$suffix : null,
              nicknames: formatNicknames((_values$nicknames = values.nicknames) !== null && _values$nicknames !== void 0 ? _values$nicknames : null)
            };
            _context.next = 5;
            return getAdapter('coreApi').updateRecord("person", contactId, newContact);
          case 5:
            callOrLog(function () {
              return trackEvent(FACESHEET.nameUpdated);
            });
            props.closeModal();
            callbacks.onClientSaved();
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var formValidator = {
    nameValidate: function nameValidate(values) {
      var isReq = isRequired(values);
      if (isReq !== null) {
        if (isEmpty(formErrors)) {
          setFormErrors(isReq);
        }
        return isReq;
      }
      return '';
    }
  };
  var contact = props.contact;
  var peopleEnums = get(enums, 'people', {});
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    initialValues: contact,
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit,
        submitting = _ref2.submitting;
      return /*#__PURE__*/React.createElement("form", {
        className: "content-with-actions",
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, !isEmpty(peopleEnums) && /*#__PURE__*/React.createElement(Field, {
        name: "title"
      }, function (params) {
        return /*#__PURE__*/React.createElement(EnumSelect, _extends({
          id: "title",
          className: "form-control",
          enums: peopleEnums.titles,
          inline: false,
          label: "Title"
        }, params));
      }), /*#__PURE__*/React.createElement(Field, {
        name: "first_name",
        validate: formValidator.nameValidate
      }, function (params) {
        return /*#__PURE__*/React.createElement(InputField, _extends({
          id: "first-name",
          inline: false,
          label: "First",
          type: "text",
          required: true
        }, params));
      }), /*#__PURE__*/React.createElement(Field, {
        name: "middle_name"
      }, function (params) {
        return /*#__PURE__*/React.createElement(InputField, _extends({
          id: "middle-initial",
          inline: false,
          label: "Middle Initial",
          maxLength: 1,
          type: "text"
        }, params));
      }), /*#__PURE__*/React.createElement(Field, {
        name: "last_name",
        validate: formValidator.nameValidate
      }, function (params) {
        return /*#__PURE__*/React.createElement(InputField, _extends({
          id: "last-name",
          inline: false,
          label: "Last",
          type: "text",
          required: true
        }, params));
      }), !isEmpty(peopleEnums) && /*#__PURE__*/React.createElement(ScrollFieldIntoView, null, /*#__PURE__*/React.createElement(Field, {
        name: "suffix"
      }, function (params) {
        return /*#__PURE__*/React.createElement(EnumSelect, _extends({
          id: "suffix",
          className: "form-control",
          enums: peopleEnums.suffix,
          inline: false,
          label: "Suffix"
        }, params));
      })), /*#__PURE__*/React.createElement(Field, {
        name: "nicknames"
      }, function (params) {
        return /*#__PURE__*/React.createElement(InputField, _extends({
          id: "nicknames",
          hint: 'Separate nicknames with a comma (",")',
          inline: false,
          label: "Nicknames",
          type: "text"
        }, params));
      })), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-personal-cancel-btn",
        disabled: submitting,
        label: "Cancel",
        onClick: onCancel
      })), /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-personal-save-btn",
        disabled: submitting,
        label: "Save",
        primary: true,
        onClick: function onClick() {
          if (!isEmpty(formErrors)) {
            setTimeout(function () {
              var _focusableErr;
              var focusableErr;
              var err = first(document.getElementsByClassName('ui-form-field--has-error'));
              if (err) {
                focusableErr = first(err === null || err === void 0 ? void 0 : err.getElementsByTagName('input'));
              }
              if (focusableErr) {
                focusableErr.ariaLabel = formErrors;
              }
              (_focusableErr = focusableErr) === null || _focusableErr === void 0 || _focusableErr.focus();
              setFormErrors({});
            }, 300);
          } else if (first(document.getElementsByClassName('ui-form-field--has-error'))) {
            var editPersonalInfoModal = document.getElementById('edit-personal-modal');
            var errInModal = first(editPersonalInfoModal === null || editPersonalInfoModal === void 0 ? void 0 : editPersonalInfoModal.getElementsByClassName('ui-form-field--has-error'));
            var focusableErr = first(errInModal === null || errInModal === void 0 ? void 0 : errInModal.getElementsByTagName('input'));
            focusableErr === null || focusableErr === void 0 || focusableErr.focus();
          }
          handleSubmit();
        }
      }))));
    }
  });
}
PersonalInformationForm.propTypes = {
  closeModal: PropTypes.func,
  contact: PropTypes.shape({
    id: PropTypes.string,
    nicknames: PropTypes.array
  }),
  shouldShowLastUpdate: PropTypes.bool,
  updateGroupContact: PropTypes.func
};
PersonalInformationForm.defaultProps = {
  shouldShowLastUpdate: false
};
export default PersonalInformationForm;
//# sourceMappingURL=PersonalInformationForm.js.map